var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.37,
    height: 27.37,
    viewBox: "0 0 27.37 27.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin",
    "data-name": "Icon awesome-linkedin",
    d: "M25.415,2.25H1.949A1.963,1.963,0,0,0,0,4.223V27.646A1.963,1.963,0,0,0,1.949,29.62H25.415a1.969,1.969,0,0,0,1.955-1.973V4.223A1.969,1.969,0,0,0,25.415,2.25ZM8.272,25.71H4.215V12.648H8.278V25.71ZM6.244,10.864A2.352,2.352,0,1,1,8.6,8.512a2.353,2.353,0,0,1-2.352,2.352ZM23.478,25.71H19.421V19.356c0-1.515-.031-3.464-2.108-3.464-2.114,0-2.438,1.65-2.438,3.354V25.71H10.82V12.648h3.892v1.784h.055a4.273,4.273,0,0,1,3.843-2.108c4.105,0,4.869,2.706,4.869,6.225Z",
    transform: "translate(0 -2.25)",
    fill: "#6aa5ac"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.73bbd6f83c12c5cb34b5d5b74909a50f.svg";
export { ForwardRef as ReactComponent };